<template>
  <MobileLayout>
    <MobileHeader :logoColor="'white'" />
    <section class="m-hero font-apercu-medium">
      <img :src="heroImage" alt="Contact" class="m-hero-image" />
      <div class="m-hero-overlay">
        <div class="m-hero-title">Contact</div>
        <div class="m-hero-sub">
			<p>We love talking to people. Tell us about your space, your</p>
			<p>brief, or simply have a wee chat with us, you will be suprised.</p>
		</div>
      </div>
    </section>

    <!-- Footer -->
   
   <Footer style="margin-top: 20rem;" />
   <div style="padding: 30rem;text-align: center;padding-bottom: 90rem;">
   	 <img src="@/assets/icon/logo_black.png"  alt="logo" style="width: 15rem;height: 19rem;" />
   </div>
   
  </MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import Footer from '@/components/mobile/footer.vue'
import MobileHeader from '@/components/mobile/header.vue'

const heroImage = require('@/assets/contact/contact1.png')
const brandLogo = require('@/assets/mobile/home/logo.png')
const contactGraphic = require('@/assets/founder/founder_slip.png')

export default {
  name: 'MobileContact',
  components: {
    MobileLayout,
    Footer,
    MobileHeader
  },
  data() {
    return {
      heroImage,
      brandLogo,
      contactGraphic
    }
  }
}
</script>

<style scoped>
.m-hero {
  position: relative;
}

.m-hero-logo {
  width: 100%;
  height: auto;
  position: absolute;
}

.m-hero-image {
  width: 100%;
  height: 258rem;
  object-fit: cover;
}

.m-hero-overlay {
  position: absolute;
  bottom: 40rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20rem;
  color: #fff;
  text-shadow: 0 2rem 10rem rgba(0, 0, 0, 0.45);
  width: 90%;
}

.m-hero-title {
  font-size: 14rem;
  font-weight: 500;
}

.m-hero-sub {
  font-size: 8rem;
  width: 68%;
  font-weight: 500;
  height: 8rem;
 line-height: 8rem;
}

.m-info {
  padding: 16rem;
  display: grid;
  grid-template-columns: 1fr 0.9fr;
  gap: 12rem;
}

.m-title {
  font-size: 11rem;
  font-weight: 700;
}

.m-title-gap {
  margin-top: 18rem;
}

.m-desc {
  font-size: 10rem;
  line-height: 1.5;
  margin-top: 8rem;
}

.m-field {
  margin-top: 14rem;
}

.m-field-label {
  font-size: 10rem;
}

.m-field-line {
  margin-top: 6rem;
  height: 1rem;
  background: #000;
  width: 90%;
}

.m-link {
  text-decoration: underline;
  text-underline-offset: 2rem;
  margin-top: 4rem;
}

.m-info-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-info-right img {
  width: 100%;
  height: auto;
}
</style>
